// v21 design tokens nest icon states under `item.icon.{color, focusColor, activeColor}`
// and use `submenu.label` instead of v19's flat `submenu.{color, labelColor, iconColor}`.
// menubar also reads `activeBackground`/`activeColor` keys (regular menu does not, but
// silently ignores them) — same constant works for both.
export const MenuDark = {
  background: '{surface.900}',
  borderColor: 'transparent',
  item: {
    color: '{surface.0}',
    focusColor: '{primary.400}',
    activeColor: '{primary.300}',
    focusBackground: '{surface.950}',
    activeBackground: 'transparent',
    icon: {
      color: '{primary.300}',
      focusColor: '{primary.400}',
      activeColor: '{primary.300}',
    },
  },
  submenu: {
    background: '{surface.900}',
    borderColor: '{surface.700}',
    label: {
      color: '{surface.300}',
    },
  },
};

// v21 select flattens option states (focusColor/selectedColor at the option level
// instead of v19's option.focus/option.selected nested objects) and renames
// clearIconColor/checkmarkColor to sub-objects (clearIcon.color, checkmark.color).
export const SelectDark = {
  color: '{surface.0}',
  background: '{surface.950}',
  disabledBackground: '{surface.600}',
  filledBackground: '{surface.950}',
  borderColor: 'transparent',
  hoverBorderColor: 'transparent',
  clearIcon: {
    color: '{surface.500}',
  },
  checkmark: {
    color: '{primary.500}',
  },
  overlay: {
    color: '{surface.0}',
    background: '{surface.800}',
    borderColor: '{surface.700}',
    shadow: '{shadow.lg}',
  },
  dropdown: {
    color: '{surface.500}',
  },
  option: {
    color: '{surface.0}',
    focusColor: '{primary.400}',
    focusBackground: '{surface.950}',
    selectedColor: '{primary.300}',
    selectedFocusColor: '{primary.400}',
    selectedBackground: '{surface.950}',
    selectedFocusBackground: '{surface.950}',
  },
  optionGroup: {
    color: '{surface.300}',
  },
};

// Dark popover for the header primary menu: no outer border, and the arrow inherits
// the surface.900 background/transparent border so it blends into the dark header
// (removes the "pointing at the wrong button" look). Shadow is kept for float depth.
export const PopoverDark = {
  background: '{surface.900}',
  borderColor: '{surface.700}',
  color: '{surface.0}',
  arrow: {
    offset:'6rem'
  }
};

export const AccordionActionCenter = {
  header: {
    border: {
      width: '0',
    },
  },
  panel: {
    border: {
      width: '0',
    }
  },
  colorScheme: {
    light: {
      header: {
        color: '{surface.800}',
        hoverColor: '{surface.800}',
        activeColor: '{primary.800}',
        background: '{surface.50}',
        activeBackground: '{surface.50}',
        hoverBackground: '{surface.50}',
      },
      content: {
        background: '{surface.50}',
      }
    }
  }
};